import React, {useEffect, useState} from 'react';

export default function SaveRecordingsComponent({sequencerEngine, selectedGuild}) {
    let recordingsToSaveCount = sequencerEngine.getAllRecordingsToSave().length;
    if (recordingsToSaveCount === 0) {
        return (
            <div></div>
        );
    }
    return (
        <div className="save-recordings">
          You have {recordingsToSaveCount} new sounds to 
          <span
            onClick={() => sequencerEngine.saveAnyNewRecordings(0)}
            className="save-recordings-button">save</span>.
        </div>
    );
}
